import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import useScreenSize from "hoc/useScreenSize";
import ProductContext from "hooks-contexts/ProductContext";
import { RootState } from "interfaces/generics.type";
import PriceRange from "modules/components/prices/range-price/PriceRange";
import dynamic from "next/dynamic";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import HideIf from "util/HideIf";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import FitmentBorder from "../fitment-border/FitmentBorder";
import { productNotFitHelper } from "../fitment-helper";
import styles from "./viewCorrectProducts.module.scss";
const ViewCorrectPartButton = dynamic(() => import(/* webpackChunkName: "view-correct-part-button" */"component/design-system/buttons/ViewCorrectPartButton"));

interface IProps {
    product: ICompactProduct;
    showOnlyButton?: boolean;
    showCategory?: boolean;
    correctPartButtonText?: string;
    correctPartButtonType?: typeof BUTTON_TYPE;
    categoryUrl?: string;
}

function ViewCorrectProducts(props: IProps) {
  const {
    product, showOnlyButton = false, showCategory = true, correctPartButtonText,
    correctPartButtonType, noFitmentBorder = false, categoryUrl,
  } = props;

  const { enCategory } = product;
  const { tier2 } = enCategory;
  const isProductNotFit = productNotFitHelper(product);
  const { categoryPageRecommendationData } = useContext(ProductContext);
  const { isCompleteVehicleSelected } = useSelector((store: RootState) => store.garage);
  const { useVehicleSelectionOptionsModal } = useSelector((store: RootState) => store.utils);

  const [isMobile] = useScreenSize();

  // Show recommended products only when category is present
  if (isProductNotFit) {
    const { href, asPath } = getHrefAndPath({ query: categoryPageRecommendationData?.queryParams, asPath: categoryPageRecommendationData?.url });

    if (showOnlyButton) {
      return (
        <ViewCorrectPartButton
          product={product}
          href={href}
          asPath={asPath}
          fullWidth
          correctPartButtonText={correctPartButtonText}
          correctPartButtonType={correctPartButtonType}
          categoryUrl={categoryUrl}
        />
      );
    }

    if (!showCategory) {
      return (
        <FitmentBorder
          product={product}
          defaultFitmentStatus="GUARANTEED_FIT"
          iconSize="big"
          noFitmentBorder={noFitmentBorder}
        >
          <ViewCorrectPartButton
            product={product}
            href={href}
            asPath={asPath}
            className={styles.correct_part_no_category}
            correctPartButtonText={correctPartButtonText}
            correctPartButtonType={correctPartButtonType}
            categoryUrl={categoryUrl}
          />
        </FitmentBorder>
      );
    }
    return (
      <FitmentBorder
        product={product}
        defaultFitmentStatus="GUARANTEED_FIT"
        iconSize="big"
        noFitmentBorder={noFitmentBorder}
      >
        <div className={styles.correct_product_link_container}>
          <div>
            <PAImage
              src={getRelativeImagePath(`/images/category-img/T1 ${tier2}.webp`)}
              width={isMobile ? 60 : 104}
              height={isMobile ? 60 : 104}
            />
          </div>
          <div className={styles.correct_product_link_button}>
            <PAText bold fontSize={FONT_SIZE[2]}>
              {tier2}
            </PAText>
            <HideIf show={!useVehicleSelectionOptionsModal || isCompleteVehicleSelected}>
              <PriceRange
                minimumPrice={categoryPageRecommendationData?.fromPrice}
                maximumPrice={categoryPageRecommendationData?.toPrice}
                className={styles.price_range}
                size={FONT_SIZE[1]}
              />
            </HideIf>
            <ViewCorrectPartButton
              product={product}
              href={href}
              asPath={asPath}
              correctPartButtonText={correctPartButtonText}
              correctPartButtonType={correctPartButtonType}
              categoryUrl={categoryUrl}
            />
          </div>
        </div>

      </FitmentBorder>

    );
  }

  return null;
}

export default ViewCorrectProducts;
